function getScrollBarWidth() {
  // if (window.innerHeight >= document.body.offsetHeight) return 0;

  // Create a temporary div element with scrollbars
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; // forcing scrollbar to appear
  outer.style.boxSizing = "content-box"; // Ensuring padding and border are not included in the calculation
  document.body.appendChild(outer);

  // Create an inner div and append it to the outer div
  const inner = document.createElement("div");
  inner.style.boxSizing = "content-box"; // Ensuring padding and border are not included in the calculation
  outer.appendChild(inner);

  // Calculate the scrollbar width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Remove the temporary elements from the DOM
  document.body.removeChild(outer);

  return scrollbarWidth;
}

export default getScrollBarWidth;
